import { render, staticRenderFns } from "./Pupil.vue?vue&type=template&id=f4ecc34e&scoped=true&"
import script from "./Pupil.vue?vue&type=script&lang=js&"
export * from "./Pupil.vue?vue&type=script&lang=js&"
import style0 from "./Pupil.vue?vue&type=style&index=0&id=f4ecc34e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ecc34e",
  null
  
)

export default component.exports